<template>
  <div id="Home">
    <div style="position: relative;">
      <img :src="firstBanner" alt="" width="100%"  style="vertical-align:top">
      <img :src="ny" alt="" width="10%"  style="vertical-align:top; position: absolute; left: 2%; top: 0;">
      <h1 style="position: absolute; left: 20%; top: 25px; color: #FFFFFF; font-size: 28px;">中国(上海)国际乐器展览会</h1>
      <p style="position: absolute; top: 30px; right: 10%;">
        <!--<img :src="phone" alt="" width="20px" style="margin: 0 5px 0 0;">
        <a href="#" style="color: #FFFFFF; font-size: 20px; text-decoration: none;">联系我们</a>-->
      </p>
      <p style="position: absolute; top: 30px; right: 5%;">
        <!--<img :src="earth" alt="" width="18px" style="margin: 0 5px 0 0;">
        <a href="#" style="color: #FFFFFF; font-size: 20px; text-decoration: none;">EN</a>-->
      </p>
    </div>
    <div class="contentWarp">
        <Sidebar />
        <div class="main-warp">
          <Navbar />
          <router-view class="page-warp" />
        </div>
    </div>
 
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/Sidebar'
import Navbar from '@/components/Navbar'
import firstBanner from '@/assets/firstBanner.png'
import ny from '@/assets/ny.png'
import phone from '@/assets/phone.png'
import earth from '@/assets/earth.png'
export default {
  name: 'home',
  components: {
    Sidebar,
    Navbar
  },
  data() {
    return {
      firstBanner:firstBanner,
      ny:ny,
      phone:phone,
      earth:earth
    }
  },
}
</script>
<style lang="less" scope>
#Home {
  height: 100%;
  display: flex;
  flex-direction: column;
  .contentWarp{
    display: flex;
    // height: 100%;
    flex: 1;
  }
  .main-warp {
    flex: 1;
    flex-direction: column;
    overflow: auto;
    display: flex;
    .page-warp {
      overflow: auto;
      padding: 10px;
      flex: 1;
    }
  }
}
</style>
